import Server from '@/service/server'

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  actions: {
    send (context: any, payload: Object) {
      let promise = Server.sendContactUs(payload)
      promise.then((response: any) => {
        // Do nothing
      })
      return promise
    }
  },
  mutations: {

  }
}
